// extracted by mini-css-extract-plugin
module.exports = {"col":"AdminDashboard_col__uBFlH","mainRow":"AdminDashboard_mainRow__mR6qK","row":"AdminDashboard_row__3-1I_"};